import { Ref, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { ProductOptionPicker } from '../Product/ProductOptionPicker';

@Component
export class StockNotification extends ThemeComponent {

    @Ref quantity!: HTMLSpanElement;
    @Ref option!: HTMLSpanElement;


    init() {
        this.setEventListeners();
    }

    setEventListeners() {

        // This component needs to listen for an event
        // on the product option picker. When a change
        // occurs, update the notification

        const productOptionPicker =
            document.querySelector('.product-main__details product-option-picker') as ProductOptionPicker;

        if (productOptionPicker) {
            this.$subscribe(productOptionPicker.onSelectedVariantChange, (option) => {

                if (option) {
                    // Get the quantity of the selected option
                    const variantInventory = productOptionPicker.variantInventoryData;
                    const selectedItem = variantInventory.find((item) => item.option == option.title);

                    if (selectedItem && (selectedItem.quantity >= 2 || selectedItem.quantity == 0)) {
                        this.hideNotification();
                        return;
                    }

                    if (selectedItem) {
                        this.quantity.innerText = String(selectedItem.quantity);
                        this.option.innerText = option ? option.title : '';
                        this.showNotification();
                    }

                }
            });
        }
    }

    hideNotification() {
        this.classList.add('visually-hidden');
    }

    showNotification() {
        this.classList.remove('visually-hidden');
    }
}
